module.exports = [
    "Mwalimu",
    "Daktari",
    "Mvuvi",
    "Mwanahabari",
    "Mwandishi",
    "Mtafiti",
    "Mhandisi",
    "Mkalimani",
    "Mhubiri",
    "Mhasibu",
    "Tarishi",
    "Bawabu",
    "Tabibu",
    "Muuguzi",
    "Dereva",
    "Nahodha",
    "Rubani",
    "Dobi",
    "Sonara",
    "Mhariri",
    "Msusi",
    "Kinyozi",
    "Hakimu",
    "Karani",
    "Meneja",
    "Kocha",
    "Dalali",
    "Seremala",
    "Mdhahiri",
    "Kaimu",


];